import React, { useMemo } from 'react';
import { AccountBalance, AssuredWorkload, Business } from "@mui/icons-material";
import BrightnessHighIcon from '@mui/icons-material/BrightnessHigh';
import CardAdministrador from "../../../../components/ui/materialui/cardAdministrador";
import { Grid2 } from "@mui/material";
import ListAltIcon from '@mui/icons-material/ListAlt';
import { usePermissions } from "../../../../components/auth/ProtectedRoute"; // Hook de permisos
import { TipoFuncionalidad } from "../../../../utils/enums"; // Enums de permisos

interface SecureLink {
    to: string;
    icon: JSX.Element; 
    text: string;
    permissions: TipoFuncionalidad[]; 
}

const ContabilidadPage: React.FC = () => {
    const { hasPermission } = usePermissions();

    const linksPermitidos = useMemo(() => {
        const todosLosLinks: SecureLink[] = [
            { 
                to: "/contabilidad/consultarMovimientosContables", 
                icon: <ListAltIcon sx={{ fontSize: 22, color: "#17c2e6" }} />, 
                text: "Movimientos contables",
                permissions: [TipoFuncionalidad.Conta_ver_movs] 
            },
            { 
                to: "/contabilidad/validadorAsientos", 
                icon: <Business sx={{ fontSize: 22, color: "#17c2e6" }} />, 
                text: "Validador de asientos contables",
                permissions: [TipoFuncionalidad.Contailidad_ADM] 
            },
            { 
                to: "/contabilidad/dividendos-recaudados", 
                icon: <AccountBalance sx={{ fontSize: 22, color: "#17c2e6" }} />, 
                text: "Dividendos recaudados",
                permissions: [TipoFuncionalidad.Conta_ver_Divs] 
            },
            { 
                to: "/contabilidad/dividendos-no-recaudados", 
                icon: <AssuredWorkload sx={{ fontSize: 22, color: "#17c2e6" }} />, 
                text: "Dividendos no recaudados",
                permissions: [TipoFuncionalidad.Conta_ver_Divs] 
            },
        ];

        return todosLosLinks.filter(link => 
            link.permissions.some(perm => hasPermission(perm))
        );
    }, [hasPermission]);

    if (linksPermitidos.length === 0) return null;

    return (
        <Grid2 container spacing={2} sx={{ mt: 2 }}>
            <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                <CardAdministrador
                    title="Contabilidad"
                    icon={<BrightnessHighIcon sx={{ fontSize: 20, color: "white" }} />}
                    links={linksPermitidos}
                    backgroundColor="#17c2e6"
                    linkTextColor="text-info"
                />
            </Grid2>
        </Grid2 >
    );
}

export default ContabilidadPage;